<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div>
      <a-row :gutter="14">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="loading.page">
            <div slot="title">
              Medical Claim Recapitulation Manifest
              <small class="m-display-block m-text-small">
                {{ source.header.no_rekap }}
              </small>
            </div>
            <a-popover slot="extra" trigger="click" placement="bottom">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li>
                  <a-button
                    @click="handlePrintManifest"
                    type="dashed"
                    icon="printer"
                    block
                    class="m-display-block"
                    :loading="loading.print"
                    >Cetak</a-button
                  >
                </li>
                <li>
                  <a-button
                    :disabled="!(source.status_besar=='Revised')"
                    @click="handleShowEditRekap"
                    type="danger"
                    icon="edit"
                    class="m-width-full"
                    :loading="dataEdited.loading"
                  >
                    Edit
                  </a-button>
                </li>
                <!-- <li>
                  <a-button-group>
                    <a-button
                      :disabled="getManifestSC.edit_sts == '0'"
                      type="dashed"
                      icon="edit"
                      @click="handleEdit"
                      >Edit</a-button
                    >
                    <a-button
                      type="dashed"
                      :disabled="getManifestSC.cancel_sts == '0'"
                      :loading="cancel_loading"
                      @click="handlecanceltrans"
                      icon="close-square"
                    >
                      Cancel
                    </a-button>
                    <a-button
                      :disabled="getManifestSC.close_sts == '0'"
                      type="dashed"
                      @click="handleclosetrans"
                      icon="close"
                    >
                      Close
                    </a-button>
                  </a-button-group>
                </li> -->
              </ul>
              <a-button :size="getScreen ? 'small' : 'default'" icon="more">{{getScreen ? '' : 'Action'}}</a-button>
            </a-popover>
            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title">Create By</span>
                  <span class="m-list-desc">{{ source.header.tlc_create }}</span>
                </li>
                <li>
                  <span class="m-list-title">Recapitulation Total</span>
                  <span class="m-list-desc">
                    <div>{{ formatCurrency('IDR',source.header.total_value) }}</div>
                    <div>({{ source.header.total_nilai_terbilang }})</div>
                  </span>
                </li>
                <li>
                  <span class="m-list-title">Description</span>
                  <span class="m-list-desc">{{ source.header.description }}</span>
                </li>
                <li>
                  <span class="m-list-title">Document Support</span>
                  <span class="m-list-desc">
                    <a-button
                      v-if="source.header.file_doc_rekap_path"
                      @click="handleViewDoc(source.header.file_doc_rekap_path)"
                      class="margin-top"
                      type="dashed"
                      icon="eye"
                      >View Document</a-button
                    >
                    <span v-else>-</span>
                  </span>
                </li>
              </ul>
            </div>
          </a-card>

          <div class="container-dash margin-top">
            <ul class="m-list-wrapper bordered">
              <li>
                <span class="m-list-title">receipt</span>
                <span class="m-list-desc" v-for="item in source.kwitansi" :key="item.jns_plafon">
                  <a-row :gutter="16" class="margin-top">
                    <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                      {{ item.jns_plafon }}
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 18 }">
                      :  {{ item.jumlah }}
                    </a-col>
                  </a-row>
                </span>
              </li>
            </ul>
          </div>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Detail list</h4>
              </div>
              <a-table
                :rowKey="(record, index) => {return index;}"
                :columns="columnsList"
                :dataSource="source.transaction_list"
                :pagination="pagination"
                size="small"
                class="table-dtl"
                :scroll="{ x: 1000 }"
                bordered
              >
                <template slot="no" slot-scope="item,data,index">
                  {{ index+1 }}
                </template>
                <template slot="no_klaim" slot-scope="item">
                  <a href="#" @click="gotoHarmoni(item)">{{ item.no_klaim }}</a>
                </template>
                <template slot="create_date" slot-scope="item">
                  {{ moment(item.create_dt).format(getStandartFormatDate) }} / {{ item.tlc_create }}
                </template>
                <template slot="member_name" slot-scope="item">
                  {{ item.nama_anggota }}
                </template>
                <template slot="total_klaim" slot-scope="item">
                  {{ formatCurrency('IDR',item.total_klaim) }}
                </template>
                <template slot="total_klaim_approved" slot-scope="item">
                  {{ formatCurrency('IDR',item.total_nilai_klaim_appr) }}
                </template>
              </a-table>
            </a-collapse-panel>
          </a-collapse>

          <a-card
            class="margin-top"
            :loading="loading.page"
            v-if="source.jenis !== 'manifest'"
          >
            <div slot="title">Manifest Actions</div>

            <a-form :form="form">
              <a-form-item label="Note">
                <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Action">
                <a-select
                  showSearch
                  v-decorator="['aksi', { rules: [{ required: true }] }]"
                >
                  <a-select-option v-for="item in source.aksi" :key="item.aksi">{{
                    item.aksi
                  }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button
                  @click="handleAction"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </a-form-item>
            </a-form>
          </a-card>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-collapse :class="getScreen ? 'margin-top' : ''" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status :status="source.status_besar" />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    <a-icon type="history" />
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">
                    Creator - {{ source.header.tlc_create }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">{{ source.header.tgl_sppd }}</h4>
                    <span class="m-text-small" v-if="source.header.remark">{{
                      source.header.remark
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">Created</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  color="green"
                  v-for="workflow in source.workflow"
                  :key="workflow.step_no"
                >
                  <div class="m-timeline-title">
                    {{ workflow.actor }} - {{ workflow.tlc }}
                  </div>
                  <div class="m-timeline-body">
                    <h4
                      class="margin-remove"
                      v-if="workflow.tanggal_aksi !== null"
                    >
                      {{ workflow.tanggal_aksi }}
                    </h4>
                    <span class="m-text-small" v-if="workflow.remark">{{
                      workflow.remark
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Related Document</h4>
              </div>
              <a-list
                itemLayout="horizontal"
                :dataSource="source.dokumen_terkait"
              >
                <Empty
                  v-if="
                    source.dokumen_terkait
                      ? source.dokumen_terkait.length <= 0
                      : source.dokumen_terkait
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      <a @click="handleView(item)"
                        >{{ item.header }} | {{ item.pembuat }}</a
                      >
                      <Status
                        :class="!getScreen ? 'margin-remove' : ''"
                        :status="item.status"
                      />
                    </div>

                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                      v-if="item.no_pp"
                    >
                      <span>{{ item.no_pp }}</span>
                    </div>
                    <div slot="description" v-if="item.tgl_mulai_dinas">
                      <span
                        >{{
                          moment(
                            item.tgl_mulai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}
                        -
                        {{
                          moment(
                            item.tgl_selesai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}</span
                      >
                    </div>
                    <div slot="description">
                      <div class="m-width-full">
                        <a-tooltip
                          class="ant-tooltip-inner"
                          placement="top"
                          :title="
                            item.deskripsi
                              ? item.deskripsi
                              : 'Tidak ada deskripsi'
                          "
                        >
                          <span class="ant-description-ellipses">{{
                            item.deskripsi
                              ? item.deskripsi
                              : "Tidak ada deskripsi"
                          }}</span>
                        </a-tooltip>
                      </div>
                    </div>
                    <div
                      slot="title"
                      v-if="item.value_transaksi && item.rest_api !== 'sppds'"
                    >
                      <span class="m-timeline-title">{{
                        formatCurrency(item.currency, item.value_transaksi)
                      }}</span>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
    </div>

    <a-modal v-model="visible.history" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="history" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in source.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }} | {{ history.tlc_to }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>

    <DialogManifestEditRekap v-if="visible.editRekap" :visible="visible.editRekap" :detail="dataEdited.source"/>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import DialogManifestEditRekap from "./DialogManifestEditRekap.vue";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import moment from "moment";
import axios from "axios";
import CryptoJS from "crypto-js";

export default {
  name: "manifestRekapKlaimKesehatan",
  components: {DialogManifestEditRekap},
  mixins: [HandleRoute, CurrencyFormat, GlobalMethod],
  props: ["id"],
  data(){
    const columnsList = [
      {
        title: "#",
        key: "no",
        width: "50px",
        align: "center",
        scopedSlots: { customRender: "no" },
        sorter: (a, b) => a.no - b.no,
      },
      {
        title: "Recapitulation Claim No",
        key: "no_klaim",
        width: "150px",
        align: "center",
        scopedSlots: { customRender: "no_klaim" },
        sorter: (a, b) => a.no_klaim - b.no_klaim,
      },
      {
        title: "Created Date / TLC",
        key: "create_date",
        width: "150px",
        align: "center",
        scopedSlots: { customRender: "create_date" },
        sorter: (a, b) => a.create_dt - b.create_dt,
      },
      {
        title: "Member Name",
        key: "member_name",
        align: "left",
        scopedSlots: { customRender: "member_name" },
        sorter: (a, b) => a.nama_anggota - b.nama_anggota,
      },
      {
        title: "Total Recapitulation Claim",
        key: "total_klaim",
        width: "180px",
        align: "right",
        scopedSlots: { customRender: "total_klaim" },
        sorter: (a, b) => a.total_klaim - b.total_klaim,
      },
      {
        title: "Total Approved",
        key: "total_klaim_approved",
        width: "180px",
        align: "right",
        scopedSlots: { customRender: "total_klaim_approved" },
        sorter: (a, b) => a.total_klaim_approved - b.total_klaim_approved,
      },
    ];

    return {
      columnsList,
      loading: {
        page: false,
        print: false
      },
      dataEdited: {
        source: null,
        loading: false
      },
      source: {
        header: [],
        history: [],
        dokumen_terkait: [],
        transaction_list: [],
        status_besar: '-',
        workflow: [],
        aksi:[],
      },
      visible: {
        history: false,
        editRekap: false,
      },
      pagination: {
        onChange: (page) => {},
        pageSize: 4,
        size: "small",
      },
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    Event.$on("closeDiagEditRec", this.closeDiagEditRec);
    Event.$on("confirmMessageReturn", this.handleActionProcess);
    Event.$on("fetchData", this.fetch);
  },
  beforeDestroy() {
    Event.$off("closeDiagEditRec", this.closeDiagEditRec);
    Event.$off("confirmMessageReturn", this.handleActionProcess);
    Event.$off("fetchData", this.fetch);
  },
  mounted(){
    this.fetch()
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStandartFormatDate",
      "getDateTimeFormat",
      "getDefaultDateFormat"
    ]),
  },
  methods:{
    moment,
    fetch(){
      this.loading.page = true
      this.asyncAxiosGet("rekap_kesehatan",
        this.getAuth,
        {
          id_rekap_klaim: this.id
        }
      ).then((res) => {
        this.source = res
      
        this.loading.page = false
      }).catch((err) => {
        this.loading.page = false
        let response = Object.assign({}, err.response);
        if (response.data.status == false && response.data.message) {
          this.displayMessageValue("error-other", response.data.message);
        } else {
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error", responses);
        }
      });
    },
    handleViewDoc(file_path){
      const url = this.$serviceUrl + file_path;
      window.open(url, "_blank");
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visible.history = !this.visible.history;
    },
    handleShowEditRekap(e){
      e.stopPropagation();

      this.dataEdited.loading = true
      this.asyncAxiosGet("rekap_kesehatan/edit",
        this.getAuth,
        {
          id_rekap_klaim: this.id
        }
      ).then((res) => {
        this.dataEdited.source = res
        this.dataEdited.source.dtl.forEach(element => {
          element['checked'] = (element.cek=='1' ? true : false)
        });
        this.dataEdited.loading = false
        this.visible.editRekap = true
      }).catch((err) => {
        this.dataEdited.loading = false
        let response = Object.assign({}, err.response);
        if (response.data.status == false && response.data.message) {
          this.displayMessageValue("error-other", response.data.message);
        } else {
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error", responses);
        }
      });
    },
    closeDiagEditRec(){
      this.visible.editRekap = false
    },
    handleAction() {
      this.confirmMessage("confirm-save");
    },
    handleActionProcess() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        let data = new FormData();
        data.append("id_manifest", this.id);
        data.append("tlc", this.getAuth.username);
        data.append("status", values.aksi);
        data.append("remark", values.catatan ? values.catatan : "");

        this.asyncAxiosPost("rekap_kesehatan/approval","formdata", this.getAuth,data)
          .then(() => {
            this.displayMessage("success");
            this.$router.go();
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      });
    },
    handlePrintManifest(){
      let formData = new FormData();
      formData.append("id_rekap_klaim", this.id);

      this.loading.print = true
      axios({
        method: "get",
        url: this.$serviceUrl + "rekap_kesehatan/cetak",
        params: {
          id_rekap_klaim: this.id
        },
        responseType: "blob",
        processData: false,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        let blob = new Blob([response.data], { type: "application/pdf" }),
          url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
        this.loading.print = false
      })
      .catch(() => {
      });
    },
    gotoHarmoni(item){
      let params = {
        usr: this.getAuth.username,
        psw: this.getAuth.password,
        id: item.id_klaim_kesehatan_hdr,
        page: "manifestKlaim",
        exp: moment().add(10, 'seconds').format(this.getDateTimeStandartFormat)
      }

      let id = CryptoJS.AES.encrypt(
      JSON.stringify(params)
      ,"IAO-key").toString()

      window.open(`${process.env.VUE_APP_HARMONI}referralFrom/${encodeURIComponent(id)}`, "_blank");
    } 
  }
}
</script>
<style lang="less">
.table-dtl{
  th{
    text-align: center!important;
  }
}
</style>